var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-2"},[_c('gallery',{attrs:{"files":_vm.files,"busy":_vm.uploadingCount > 0},on:{"delete":_vm.deleteFile,"upload":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }